<template>
	<div class="company-oems-card">
		<div class="company-oems-card__item">
			<i :class="['icon', status]" />
			<span class="company-oems-card__item">
				{{ item.manufacturer }}
			</span>
		</div>
		<span class="company-oems-card__item"> Module: {{ item.module }} </span>
		<span class="company-oems-card__item">
			Dealer ID: {{ item.dealerId }}
		</span>
	</div>
</template>

<script>
export default {
	name: 'CompanyOEMSCard',
	components: {},
	props: {
		item: {
			type: Object,
			default: () => {}
		}
	},
	computed: {
		status() {
			return !this.item.inactive
				? 'icon-positive-solid'
				: 'icon-indeterminate-solid';
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/scss/5-objects/_cards.scss';

.company-oems-card {
	@include card;

	&__item {
		display: block;
	}
}
</style>
